(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-qr-generator"] && !Shopify.designMode) return;
  try {
    

(function () {

  /*
   * --------------------------------------------------
   * QR Code initialization
   * --------------------------------------------------
   */

  function generateQrCodes(root) {

    if (!root) {
      return;
    }

    /*
     * qrcode-generator.js 加载完成之后，
     * 会在 window 上提供 qrcode()。
     */

    if (typeof window.qrcode !== 'function') {

      /*
       * 如果外部 JS 还没加载完成，
       * 稍后重试。
       */

      setTimeout(function () {
        generateQrCodes(root);
      }, 100);

      return;
    }


    var cards = root.querySelectorAll(
      '.sfd-qr-card'
    );


    cards.forEach(function (card) {

      var target = card.querySelector(
        '.sfd-qr-code'
      );

      if (!target) {
        return;
      }


      var url = card.dataset.qrUrl;

      if (!url) {
        return;
      }


      var size = parseInt(
        card.dataset.qrSize || '6',
        10
      );


      var margin = parseInt(
        card.dataset.qrMargin || '4',
        10
      );


      var errorCorrection =
        card.dataset.qrError || 'M';


      try {

        /*
         * typeNumber = 0
         *
         * 自动选择 QR Version。
         */

        var qr = window.qrcode(
          0,
          errorCorrection
        );


        /*
         * 使用 Byte 模式编码 URL。
         */

        qr.addData(
          url,
          'Byte'
        );


        /*
         * 生成二维码矩阵。
         */

        qr.make();


        /*
         * 直接输出 SVG。
         */

        var svg = qr.createSvgTag({
          cellSize: size,
          margin: margin,
          scalable: true
        });


        target.innerHTML = svg;


        var svgElement =
          target.querySelector('svg');


        if (svgElement) {

          svgElement.setAttribute(
            'role',
            'img'
          );

          svgElement.setAttribute(
            'aria-label',
            'QR Code'
          );

          svgElement.style.width = '100%';

          svgElement.style.height = 'auto';

          svgElement.style.display = 'block';

        }

      } catch (error) {

        console.error(
          '[SFD QR] QR generation failed:',
          error
        );

        target.innerHTML =
          '<p>QR Code generation failed.</p>';

      }

    });

  }


  /*
   * --------------------------------------------------
   * Initialize all SFD QR sections
   * --------------------------------------------------
   */

  function init() {

    var sections =
      document.querySelectorAll(
        '.sfd-qr-section'
      );


    sections.forEach(function (section) {

      generateQrCodes(section);

    });

  }


  /*
   * Normal page load
   */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  /*
   * --------------------------------------------------
   * Shopify Theme Editor
   * --------------------------------------------------
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section =
        event.target.querySelector
          ? event.target.querySelector(
              '.sfd-qr-section'
            )
          : null;


      if (section) {

        generateQrCodes(section);

      }

    }
  );


})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sfd-business-cards"] && !Shopify.designMode) return;
  try {
    

/* ============================================================
   SoulFeed Diary
   Business Card QR Generator
   ============================================================ */

(function () {

  'use strict';


  /* ----------------------------------------------------------
     Generate QR codes inside one section
     ---------------------------------------------------------- */

  function generateQrCodes(section) {

    if (!section) {
      return;
    }


    /*
     * qrcode-generator.js exposes:
     *
     * window.qrcode
     */

    if (typeof window.qrcode !== 'function') {

      /*
       * The library may still be loading.
       *
       * Try again shortly.
       */

      setTimeout(function () {

        generateQrCodes(section);

      }, 100);

      return;
    }


    var cards =
      section.querySelectorAll(
        '.sfd-business-card'
      );


    cards.forEach(function (card) {

      var url =
        card.getAttribute(
          'data-wecom-url'
        );


      var container =
        card.querySelector(
          '[data-qr-container]'
        );


      if (!url || !container) {
        return;
      }


      try {

        /*
         * --------------------------------------------------
         * QR Code
         *
         * 0 = automatically select QR Version
         *
         * H = high error correction
         * --------------------------------------------------
         */

        var qr =
          window.qrcode(
            0,
            'H'
          );


        /*
         * WeCom URL
         *
         * Byte mode is appropriate for URLs.
         */

        qr.addData(
          url,
          'Byte'
        );


        /*
         * Build QR matrix.
         */

        qr.make();


        /*
         * Generate SVG.
         */

        var svg =
          qr.createSvgTag({
            cellSize: 4,
            margin: 4,
            scalable: true
          });


        /*
         * Replace loading indicator.
         */

        container.innerHTML = svg;


        /*
         * SVG accessibility.
         */

        var svgElement =
          container.querySelector(
            'svg'
          );


        if (svgElement) {

          svgElement.setAttribute(
            'role',
            'img'
          );


          svgElement.setAttribute(
            'aria-label',
            'WeCom QR Code'
          );


          svgElement.style.width =
            '100%';


          svgElement.style.height =
            '100%';


          svgElement.style.display =
            'block';

        }

      } catch (error) {

        console.error(
          '[SFD Business Card] QR generation failed:',
          error
        );


        container.innerHTML =
          '<span class="sfd-business-card__qr-loading">QR unavailable</span>';

      }

    });

  }


  /* ----------------------------------------------------------
     Initialize section
     ---------------------------------------------------------- */

  function initSection(section) {

    if (!section) {
      return;
    }


    generateQrCodes(section);

  }


  /* ----------------------------------------------------------
     Initialize all sections
     ---------------------------------------------------------- */

  function init() {

    var sections =
      document.querySelectorAll(
        '.sfd-business-cards'
      );


    sections.forEach(function (section) {

      initSection(section);

    });

  }


  /* ----------------------------------------------------------
     Normal page load
     ---------------------------------------------------------- */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  /* ----------------------------------------------------------
     Shopify Theme Editor
     ---------------------------------------------------------- */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section =
        event.target.querySelector
          ? event.target.querySelector(
              '.sfd-business-cards'
            )
          : null;


      if (section) {

        initSection(section);

      }

    }
  );


})();


  } catch(e) { console.error(e); }
})();
})();
